import { useContext } from 'react';
import ConversationProviderContext from '../stores/contexts/conversation-context';

function useConversation() {
  const context = useContext(ConversationProviderContext);

  if (!context) throw new Error('useConversation must be used within a ConversationProvider');

  return context;
}

export default useConversation;
